import "./Chats.css";
import {
  IonContent,
  IonHeader,
  IonPage,
  useIonViewWillEnter,
} from "@ionic/react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { getAllChats } from "../../redux/actions/chatActions";
import Spinner from "../../components/Spinner";

import { useState } from "react";
import ChatItem from "./ChatItem";
import Header from "../../components/layout/Header";
import { Helmet } from "react-helmet-async";

const Chats = () => {
  const chatState = useSelector((state) => state.chat);
  const currentProfile = useSelector((state) => state.currentProfile.data);
  const { chats, unread } = chatState;
  const { t } = useTranslation();
  const [showRequests, setShowRequests] = useState(false);

  const dispatch = useDispatch();

  useIonViewWillEnter(() => {
    dispatch(getAllChats());
    setShowRequests(false);
  });

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <IonPage>
        <IonHeader mode="ios">
          <Header />
        </IonHeader>
        <IonContent>
          {chats ? (
            chats.length > 0 ? (
              (() => {
                const normalChats = chats.filter((c) => !c.isRequest);
                const requestChats = chats.filter((c) => c.isRequest);

                return (
                  <div className="chats-container">
                    {!showRequests ? (
                      <>
                        {requestChats.length > 0 && (
                          <div
                            className="message-requests-toggle cursor-pointer display-flex align-items-center justify-content-between p-3 border-bottom"
                            onClick={() => setShowRequests(true)}
                            style={{
                              padding: "15px",
                              borderBottom: "1px solid var(--border)",
                              cursor: "pointer",
                            }}
                          >
                            <div className="display-flex align-items-center">
                              <h3
                                style={{
                                  margin: 0,
                                  fontSize: "16px",
                                  fontWeight: "bold",
                                }}
                              >
                                Message requests ({requestChats.length})
                              </h3>
                              <i className="fa-solid fa-chevron-right"></i>
                            </div>
                          </div>
                        )}
                        {normalChats.length > 0 ? (
                          normalChats.map((c) => {
                            return (
                              <ChatItem
                                key={c._id}
                                chat={c}
                                currentProfile={currentProfile}
                                unreadCount={
                                  unread?.chats?.find(
                                    ({ chatId }) => chatId === c._id,
                                  )?.count
                                }
                              />
                            );
                          })
                        ) : (
                          <div className="display-flex flex-direction-c">
                            <div className="view-wrapper">
                              <h1>{t("noChatsTitle")}</h1>
                              <p>{t("noChatsSubtitle")}</p>
                            </div>
                          </div>
                        )}
                      </>
                    ) : (
                      <>
                        <div
                          className="message-requests-header cursor-pointer display-flex align-items-center p-3 border-bottom"
                          onClick={() => setShowRequests(false)}
                          style={{
                            padding: "15px",
                            borderBottom: "1px solid var(--border)",
                            cursor: "pointer",
                          }}
                        >
                          <i
                            className="fa-solid fa-chevron-left"
                            style={{ marginRight: "10px", fontSize: "16px" }}
                          ></i>
                          <h3
                            style={{
                              margin: 0,
                              fontSize: "16px",
                              fontWeight: "bold",
                            }}
                          >
                            Message requests
                          </h3>
                        </div>
                        {requestChats.length > 0 ? (
                          requestChats.map((c) => {
                            return (
                              <ChatItem
                                key={c._id}
                                chat={c}
                                currentProfile={currentProfile}
                                unreadCount={
                                  unread?.chats?.find(
                                    ({ chatId }) => chatId === c._id,
                                  )?.count
                                }
                              />
                            );
                          })
                        ) : (
                          <div className="display-flex flex-direction-c">
                            <div className="view-wrapper">
                              <h1>{t("noChatsTitle")}</h1>
                              <p>{t("noChatsSubtitle")}</p>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                );
              })()
            ) : (
              <div className="display-flex flex-direction-c">
                <div className="view-wrapper">
                  <h1>{t("noChatsTitle")}</h1>
                  <p>{t("noChatsSubtitle")}</p>
                </div>
              </div>
            )
          ) : (
            <Spinner />
          )}
        </IonContent>
      </IonPage>
    </>
  );
};

export default Chats;

